module.exports = __webpack_public_path__ + "static/img/079_TO8_1721_og.3010e34.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/079_TO8_1721_og.jpg
// module id = FAZC
// module chunks = 0